// Datos de productos para Masas Patrones
export const masasPatrones = [
  {
    id: 800,
    categoria: 'masas-patrones',
    nombre: 'MASAS PATRON TIPO MALETA',
    descripcion: 'Pesas patrón de hierro fundido robustas y estables, diseñadas para verificación y calibración de balanzas industriales (mesa, plataforma y, en conjunto, básculas de mayor capacidad) ',
    descripcion2: 'Su construcción maciza minimiza la deriva por golpes o vibraciones y el acabado anti-corrosivo garantiza larga vida útil en bodegas y plantas. ',
    imagen: '/imagenes/productos/MasasPatrones/masa_fierro1.webp',
    caracteristicas: [
      {
        titulo: 'Características',
        items: [
          '•	Material: hierro fundido de alta densidad.',
          '•	Acabado: pintura epóxica negra/horno anticorrosiva y fácil de limpiar.',
          '•	Con asa/agarre integrado para 1–20 kg (maniobra segura).',
          '•	Ajuste metrológico: cavidad/tornillo de ajuste sellable para puesta a punto.',
          '•	Unidades: kg ',
          '•	Clase metrológica: OIML M1/M2/M3 ',
          '•	Trazabilidad: aptas para emisión de certificado de calibración por laboratorio acreditado ',
          '•	Identificación: marcado durable del valor nominal y/o código.',
          
        ]
      },
    ],
    opciones: [
      {
        id: 'masa-patron-maleta-1kg',
        nombre: '1KG',
        
      },
      {
        id: 'masa-patron-maleta-2kg',
        nombre: '2KG',
        
      },
      
      {
        id: 'masa-patron-maleta-5kg',
        nombre: '5KG',
        
      },
      
      {
        id: 'masa-patron-maleta-10kg',
        nombre: '10KG',
        
      },
      
      {
        id: 'masa-patron-maleta-20kg',
        nombre: '20KG',
        
      },
      
    ],
    imagenes: [
      '/imagenes/productos/MasasPatrones/masa_fierro1.webp',
      '/imagenes/productos/MasasPatrones/masa_fierro2.webp',


    ]
  },
  {
    id: 801,
    categoria: 'masas-patrones',
    nombre: 'MASAS PATRONES CILÍNDRICAS INOXIDABLES',
    descripcion: ' Pesas patrón cilíndricas fabricadas en acero inoxidable de alta pureza, ideales para calibración y verificación de balanzas de laboratorio, mesa y plataforma.  ',
    descripcion2: ' Su acabado pulido espejo y la estabilidad del material aseguran baja adherencia de polvo, alta resistencia a la corrosión y excelente estabilidad dimensional. ',
    imagen: '/imagenes/productos/MasasPatrones/masa_inox1.webp',
    caracteristicas: [
      {
        titulo: 'Características',
        items: [
          '•	Material: acero inoxidable austenítico (alta resistencia a la corrosión, baja magnetización).',
          '•	Diseño: formato cilíndrico con botón/knob para manipulación segura ',
          '•	Acabado: pulido espejo para minimizar contaminación superficial y facilitar limpieza.',
          '•	Ajuste metrológico: cavidad/tornillo de ajuste sellable ',
          '•	Marcado: valor nominal grabado en cada pesa (kg/g).',
          '•	Rango nominal: desde 1 g hasta 20 kg por unidad.',
          '•	Unidades: g y kg.',
          '•	Trazabilidad: opción de certificado de calibración emitido por laboratorio ',
          '•	Presentación: estuche individual ',
          
        ]
      },
    ],
    opciones: [
      {
        id: 'masa-patron-maleta-1g',
        nombre: '1G',
        
      },
      {
        id: 'masa-patron-maleta-2g',
        nombre: '2G',
        
      },
      
      {
        id: 'masa-patron-maleta-5g',
        nombre: '5G',
        
      },
      
      {
        id: 'masa-patron-maleta-10g',
        nombre: '10G',
        
      },
      
      {
        id: 'masa-patron-maleta-20g',
        nombre: '20G',
        
      },
      {
        id: 'masa-patron-maleta-50g',
        nombre: '50G',
        
        },
      
      {
        id: 'masa-patron-maleta-100g',
        nombre: '100G',
        
      },
      
      {
        id: 'masa-patron-maleta-200g',
        nombre: '200G',
        
      },
      
      
      {
        id: 'masa-patron-maleta-500g',
        nombre: '500G',
        
      },
      
      {
        id: 'masa-patron-maleta-1kg',
        nombre: '1KG',
        
      },
      {
        id: 'masa-patron-maleta-2kg',
        nombre: '2KG',
        
      },
      
      {
        id: 'masa-patron-maleta-5kg',
        nombre: '5KG',
        
      },
      {
        id: 'masa-patron-maleta-10kg',
        nombre: '10KG',
        
      },
      
      {
        id: 'masa-patron-maleta-20kg',
        nombre: '20KG',
        
      },
      
      
      

      

      
    ],
    imagenes: [
      '/imagenes/productos/MasasPatrones/masa_inox1.webp',
      '/imagenes/productos/MasasPatrones/masa_inox2.webp',
      '/imagenes/productos/MasasPatrones/masa_inox3.webp',


    ]
  },
];

export default masasPatrones;
